import React, { useState } from 'react';

const NusmaHeader = ({ 
  currentPage = 'inicio', 
  onNavigate = () => {}, 
  isMenuOpen = false, 
  onToggleMenu = () => {} 
}) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-gray-800 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-red-900 rounded-xl flex items-center justify-center shadow-lg">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">NUSMA</h1>
              <p className="text-xs text-gray-400 -mt-1">AI Compliance Solutions</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => onNavigate('inicio')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                currentPage === 'inicio'
                  ? 'bg-red-900 text-red-100 shadow-sm'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => onNavigate('productos')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                currentPage === 'productos'
                  ? 'bg-red-900 text-red-100 shadow-sm'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Productos
            </button>
            <button
              onClick={() => onNavigate('servicios')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                currentPage === 'servicios'
                  ? 'bg-red-900 text-red-100 shadow-sm'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => onNavigate('contacto')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                currentPage === 'contacto'
                  ? 'bg-red-900 text-red-100 shadow-sm'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Contacto
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <button
              onClick={() => onNavigate('demo')}
              className="bg-gradient-to-r from-red-600 to-red-900 text-white px-6 py-2.5 rounded-xl text-sm font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
            >
              Solicitar Demo
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={onToggleMenu}
            className="md:hidden p-2 rounded-lg text-gray-300 hover:text-white hover:bg-gray-800 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-800 py-4 space-y-2">
            <button
              onClick={() => {
                onNavigate('inicio');
                onToggleMenu();
              }}
              className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                currentPage === 'inicio'
                  ? 'bg-red-900 text-red-100'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => {
                onNavigate('productos');
                onToggleMenu();
              }}
              className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                currentPage === 'productos'
                  ? 'bg-red-900 text-red-100'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Productos
            </button>
            <button
              onClick={() => {
                onNavigate('servicios');
                onToggleMenu();
              }}
              className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                currentPage === 'servicios'
                  ? 'bg-red-900 text-red-100'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => {
                onNavigate('contacto');
                onToggleMenu();
              }}
              className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                currentPage === 'contacto'
                  ? 'bg-red-900 text-red-100'
                  : 'text-gray-300 hover:text-white hover:bg-gray-800'
              }`}
            >
              Contacto
            </button>
            <button
              onClick={() => {
                onNavigate('demo');
                onToggleMenu();
              }}
              className="w-full mt-4 bg-gradient-to-r from-red-600 to-red-900 text-white px-6 py-3 rounded-xl text-sm font-semibold shadow-lg"
            >
              Solicitar Demo
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default NusmaHeader;